import {useCallback, useMemo} from 'react';

export const useProductFilters = (
	filters,
	setFilters,
	resetPage,
	resetFilter,
	toggleFilters,
	showFilter
) => {
	// Apply filters
	const applyFilters = useCallback((appliedFilters) => {
		const filterUpdates = {
			brand_id: appliedFilters.brands || [],
			cat_id: appliedFilters.categories || [],
			sub_cat_id: appliedFilters.subcategories || [],
			country_id: appliedFilters.countries || [],
			diet_id: appliedFilters.dietary || [],
			min: parseInt(appliedFilters.minPrice) || 0,
			max: parseInt(appliedFilters.maxPrice) || 1000,
			promotion: appliedFilters.showPromotion || false,
			oos: appliedFilters.showOutOfStock || false,
			sort: appliedFilters.sort || 'a-z',
			q: appliedFilters.q
		};

		setFilters(filterUpdates);  // Don't spread filters - just set new values
		resetPage(1);

		if (showFilter) {
			toggleFilters();
		}
	}, [setFilters, resetPage, showFilter, toggleFilters]);  // Removed filters dependency

	// Clear filters
	const clearFilters = useCallback(() => {
		resetFilter();
		resetPage(1);

		if (showFilter) {
			toggleFilters();
		}
	}, [resetFilter, resetPage, showFilter, toggleFilters]);

	// Prepare initial filters - use specific values, not entire object
	const initialFilters = useMemo(() => ({
		brand_id: filters?.brand_id,
		cat_id: filters?.cat_id,
		sub_cat_id: filters?.sub_cat_id,
		country_id: filters?.country_id,
		diet_id: filters?.diet_id,
		min: filters?.min,
		max: filters?.max,
		promotion: filters?.promotion,
		oos: filters?.oos,
		sort: filters?.sort,
		q: filters?.q,
	}), [
		// Convert arrays to strings for stable comparison - prevents infinite loop
		filters?.brand_id?.join(','),
		filters?.cat_id?.join(','),
		filters?.sub_cat_id?.join(','),
		filters?.country_id?.join(','),
		filters?.diet_id?.join(','),
		filters?.min,
		filters?.max,
		filters?.promotion,
		filters?.oos,
		filters?.sort,
		filters?.q,
	]);

	return {
		applyFilters,
		clearFilters,
		initialFilters,
	};
};